<template>
  <div class="summary-holder">
    <h1>{{ t.summary }}</h1>

    <p>
    Kedves Vásárlónk!<br/>
    Az alábbiakban látja rendelése részleteit.
    </p>

    <div class="row">
      <div class="col-md-6">
        <h2>{{ t.invoice_info }}</h2>
        <p>{{ orderSummaryData.invoice_address }}</p>
      </div>

      <div class="col-md-6" v-if="orderSummaryData.shipping_address">
        <h2>{{ t.shipping_info }}</h2>
        <p>{{ orderSummaryData.shipping_address }}</p>
      </div>
    </div>

    <div class="row" v-if="productData.products_count">
      <div class="col-md-12">
        <h2>{{ t.products }}</h2>
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>{{ t.name }}</th>
              <th class="text-right">{{ t.quantity }}</th>
              <th class="text-right">{{ t.net_unit_price }}</th>
              <th class="text-right">{{ t.net_price }}</th>
              <th class="text-right">{{ t.vat }}</th>
              <th class="text-right">{{ t.gross_price }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(p, pidx) in productData.products" v-bind:key="pidx">
              <td v-html="p.name_url"></td>
              <td class="text-right">{{ p.quantity }} db</td>
              <td class="text-right">{{ p.net_unit_price }}</td>
              <td class="text-right">{{ p.net_price }}</td>
              <td class="text-right">{{ p.tax_value }}</td>
              <td class="text-right">{{ p.gross_price }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-12">
        <h2>{{ t.shipping_and_payment }}</h2>

        <table class="table table-striped table-bordered">
          <tbody>
            <tr>
              <td>{{ orderSummaryData.shipping_type }}, {{ orderSummaryData.payment_type }}</td>
              <td v-if="!customShippingPrice" class="text-right">
                {{ orderSummaryData.shipping_total_gross }}
              </td>

              <td v-if="customShippingPrice" class="text-right">
                {{ t.custom_shipping_method }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ t.to_be_paid }}:</strong></td>
              <td class="text-right"><strong>{{ t.total }}:</strong> {{ orderSummaryData.total_price }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-12">

        <label for="comment">{{ t.comment }}</label>
        <textarea class="form-control" rows="4" id="comment" v-model="formData.comment"></textarea>

        <p v-if="!isSimplePay">
          <strong v-html="t.order_thank_you"></strong>
        </p>

        <p v-if="isSimplePay">
          <strong v-html="t.order_thank_you_simple_pay"></strong>
        </p>

      </div>

    </div>

    <div class="webshop-step-holder">

      <div class="webshop-step-left">
        <div class="step-button">
          <router-link :to="{ name: 'Shipping' }" class="btn btn-primary">
            <i class="fa fa-arrow-left" aria-hidden="true"></i> {{ t.back }}
          </router-link>
        </div>
      </div>

      <div class="webshop-step-right">
        <div v-if="!isSimplePay" class="step-button">
          <button class="btn btn-primary" v-on:click="saveOrder">{{ t.order_button_text }} <i class="fa fa-cart-arrow-down" aria-hidden="true"></i></button>
        </div>

        <div v-if="isSimplePay" class="step-button">
          <button class="btn btn-primary" v-on:click="saveOrder">{{ t.order_button_text_simple_pay }} <i class="fa fa-credit-card" aria-hidden="true"></i></button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'Summary',
  data() {
    return {
      customShippingPrice: 0,
      isSimplePay: 0,
    }
  },
  computed: {
    ...mapGetters({
      t: "getLanguageData",
      error: "getErrorData",
      userData: "getUserData",
      productData: "getProductData",
      orderData: "getOrderData",
      settingData: "getSettingData",
      formData: "getFormData",
      orderSummaryData: "getOrderSummaryData",
      currentStep: "getCurrentStep",
    }),
  },
  methods: {
    saveOrder: function (){
      let $this = this;

      let formData = {
        'page'    : 'Summary',
        'method'  : 'SaveOrder',
        'formData': $this.formData
      };

      $this.$store.dispatch('setData', formData);
    },
    getArrayItem: function ($addressArray, $addressId){
      for(let i in $addressArray){
        let item = $addressArray[i];
        if(parseInt(item.id) === parseInt($addressId)){
          return item;
        }
      }
      return null;
    },
  },
  created() {
    this.customShippingPrice = 0;
    this.isSimplePay = 0;
    window.scrollTo({ top: 0, behavior: 'smooth' });

    let $shippingType = this.getArrayItem(this.orderData.shippingArray, this.formData.shippingId);
    let $paymentType = this.getArrayItem(this.orderData.paymentArray, this.formData.paymentId);

    if(this.orderData.shippingCustom === 1 && $shippingType.is_custom === 1){
      this.customShippingPrice = 1;
    }

    if($paymentType && $paymentType.is_credit_card === 1){
      this.isSimplePay = 1;
    }

    this.$store.commit("setCurrentStep", 'Summary');
  },
  updated() {
    // Ha "saveOrder" lefutott és súlyos hiba volt, akkor Cart oldalra dobom reload-olva...
    if(this.currentStep === 'Cart'){
      window.location.href = '/webshop/step/cart'
    }
    // Köszönő oldalra dobom, ha mentés sikeres
    if(this.currentStep && this.currentStep !== 'Summary'){
      window.location.href = this.currentStep;
    }
  },
}
</script>